import axios from 'axios';
import { dispatch } from '../store';
import Config from '../configs/config';
import keycloak from '../configs/keycloak';

/**
 * Axios defaults
 */
axios.defaults.baseURL = Config.apiBaseUrl;
// axios.defaults.withCredentials = true;

// Headers
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Accept = 'application/json';

/**
 * Request Interceptor
 */
axios.interceptors.request.use(
  async (inputConfig) => {
    const config = inputConfig;
    try {
      const access_token = keycloak.token;

      if (access_token && access_token !== 'undefined') {
        // @ts-ignore
        config.headers.common.Authorization = `Bearer ${access_token}`;
      }
    } catch (error) {
      /* Nothing */
    }

    return config;
  },
  (error) => {
    throw error;
  },
);

/**
 * Response Interceptor
 */
axios.interceptors.response.use(
  (res) => {
    // Status code isn't a success code - throw error
    if (!`${res?.status}`.startsWith('2')) {
      throw res.data;
    }

    // Otherwise just return the data
    if (res.data && typeof res.data === 'object') {
      res.data.timeStamp = Date.now();
    }

    return res;
  },

  async (error) => {
    if (error?.response?.status === 401) {
        keycloak?.updateToken?.();
        dispatch.util.sendAlert({
            snackbarMessage: 'مشکلی پیش آمده ! دوباره تلاش کنید',
            snackbarOpen: true,
            snackBarSeverity: 'error',
        });
    }

    if (error?.response?.status >= 400 && error?.response?.status < 500) {
        dispatch.util.sendAlert({
            snackbarMessage: 'مشکلی پیش آمده ! دوباره تلاش کنید',
            snackbarOpen: true,
            snackBarSeverity: 'error',
        });
    }

    if (error?.response?.status >= 500) {
      dispatch.util.sendAlert({
        snackbarMessage: 'مشکلی پیش آمده ! دوباره تلاش کنید',
        snackbarOpen: true,
        snackBarSeverity: 'error',
      });
    }
    return Promise.reject(error);
  },
);

export default axios;
